<template>
<v-layout fluid fill-height>
    <v-flex row wrap>
        <v-card min-height="100px" min-width="100px" height="100%" class="pa-2">
            <upload-actuals :plantID="plantID">
            </upload-actuals>
        </v-card>
    </v-flex>
</v-layout>
</template>

<script>
import UploadActuals from '@/components/plants/UploadActuals.vue';

export default {
    components: {
        UploadActuals
    },
    props: [
        'plantID'
    ],
    data() {
        return {
            loading: false
        };
    },
    methods: {

    }
}
</script>